export default "__VITE_ASSET__HsqvKFlt__"